export default __webpack_public_path__ + "static/media/Chatpong_logo_trans.6ed16f98.png";